import {
  ChartType,
  DataWidget as DataWidgetType,
  isDataWidgetCounter,
  isDataWidgetLeaderboardBar,
  isDataWidgetLeaderboardTable,
  isDataWidgetPie,
  isDataWidgetTable,
  isDataWidgetTimeseriesBar,
  isDataWidgetTimeseriesBarGrouped,
  isDataWidgetTimeseriesBarStacked,
  isDataWidgetTimeseriesHeatmap,
  isDataWidgetTimeseriesLine,
} from 'types/dashboard_widget';

import { Counter } from 'dashboards/charts/Counter';
import { DataGrid } from 'dashboards/charts/DataGrid';
import { HeatmapChart } from 'dashboards/charts/HeatmapChart';
import { Leaderboard } from 'dashboards/charts/Leaderboard';
import { LeaderboardTable } from 'dashboards/charts/LeaderboardTable';
import { PieChart } from 'dashboards/charts/PieChart';
import { StackedBarChart } from 'dashboards/charts/StackedBarChart';
import { TimeSeries } from 'dashboards/charts/TimeSeries';

export function DataWidget(widget: DataWidgetType<ChartType>) {
  switch (true) {
    case isDataWidgetTimeseriesBar(widget):
      return <TimeSeries widget={widget} variant="bar" />;
    case isDataWidgetTimeseriesLine(widget):
      return <TimeSeries widget={widget} variant="line" />;
    case isDataWidgetLeaderboardBar(widget):
      return <Leaderboard widget={widget} />;
    case isDataWidgetTimeseriesBarStacked(widget):
      return <StackedBarChart widget={widget} variant="stacked" />;
    case isDataWidgetTimeseriesBarGrouped(widget):
      return <StackedBarChart widget={widget} variant="grouped" />;
    case isDataWidgetTimeseriesHeatmap(widget):
      return <HeatmapChart widget={widget} />;
    case isDataWidgetLeaderboardTable(widget):
      return <LeaderboardTable widget={widget} />;
    case isDataWidgetPie(widget):
      return <PieChart widget={widget} />;
    case isDataWidgetTable(widget):
      return <DataGrid widget={widget} />;
    case isDataWidgetCounter(widget):
      return <Counter widget={widget} />;
    default:
      return null;
  }
}
